
import { Component, OnInit, ViewChild, EventEmitter, OnDestroy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { NotificationService } from 'src/app/shared/notification.service';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { Observable, Subscription, combineLatest, from, merge, of } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { CollectionReference } from '@angular/fire/compat/firestore';
import { SystemService } from '../../../services/system.service';
import { SitesCategoryPopup } from './sites-category-popup/sites-category-popup';
import {  map } from 'rxjs/operators';
import { CategoryDetailPopup } from './category-detail-popup/category-detail-popup';

export interface PeriodicElement {
  name: string;
  id: number;
  email: string;
  rfid: number;
  status: boolean;
  type: boolean;
  dbid: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})


export class SiteCategoryComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['id', 'name', 'email', 'credit', 'status', 'type', 'detail', 'view', 'edit'];
  @Input() inputSiteId: string;
  approvedDataSource = new MatTableDataSource(ELEMENT_DATA);
  // notApprovedDataSource = new MatTableDataSource(ELEMENT_DATA);
  siteId: string;
  user: User;
  categories$: Observable<{}>;
  dbPath: CollectionReference;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  siteId$: Observable<any>;

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Name',
      maxLengthOnMobile: 10
    },
    {
      columnId: 'subsidyActive',
      name: 'Subsidy Active',
      maxLengthOnMobile: 10
    },
    {
      columnId: 'subsidy',
      name: 'Subsidy %',
      maxLengthOnMobile: 10
    },
    {
      columnId: 'subsidyForGuests',
      name: 'Guests',
      maxLengthOnMobile: 10
    }]

  onDelete: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onImport: EventEmitter<ActionButtonEvent>;
  onEdit: EventEmitter<ActionButtonEvent>;

  onDeleteSubscription: Subscription;
  onAddSubscription: Subscription;
  onImportSubscription: Subscription;
  onEditSubscription: Subscription;
  dialogSub: Subscription;
  paramsSub: Subscription;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: any; }[] = [];



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public auth: AuthService,
    public systemService: SystemService,
    private notifierService: NotificationService
  ) {





    this.onDelete = new EventEmitter<ActionButtonEvent>();
    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onImport = new EventEmitter<ActionButtonEvent>();
    this.onEdit = new EventEmitter<ActionButtonEvent>();


    this.onDeleteSubscription = this.onDelete.subscribe(event => {
      this.deleteUser(event.eventData.sitedbid);
    });

    this.onAddSubscription = this.onAdd.subscribe(event => {
      this.addCategory();
    });

    this.onEditSubscription = this.onEdit.subscribe(event => {
      this.showDetail(event.eventData);
    });


    this.auth.user$.subscribe(user => {
      this.user = user;
      // console.log(this.rowActionButtons.filter(b=> b.icon == 'edit').length)
      if (this.rowActionButtons.filter(b => b.icon == 'edit').length == 0 && this.auth.canEdit(this.user)) {
        this.rowActionButtons.push({ icon: 'edit', tooltip: 'Edit', eventEmitter: this.onEdit });
      } else if (!this.auth.canEdit(this.user)) {
        let eIndex = this.rowActionButtons.findIndex(b => b.icon == 'edit')
        if (eIndex > -1) {
          this.rowActionButtons.splice(eIndex, 1);
        }
      }

      if (this.topbarActionButton.filter(b => b.icon == 'add').length == 0 && this.auth.canEdit(this.user)) {
        this.topbarActionButton.push({ icon: 'add', tooltip: 'Add Category', eventEmitter: this.onAdd });
      } else if (!this.auth.canEdit(this.user)) {
        let aIndex = this.topbarActionButton.findIndex(b => b.icon == 'add')
        if (aIndex > -1) {
          this.topbarActionButton.splice(aIndex, 1);
        }
      }


      if (this.rowActionButtons.filter(b => b.icon == 'clear').length == 0 && this.auth.canDelete(this.user))
        this.rowActionButtons.push({ icon: 'clear', tooltip: 'Remove', eventEmitter: this.onDelete });
      else if (!this.auth.canDelete(this.user)) {
        let index = this.rowActionButtons.findIndex(b => b.icon == 'clear')
        if (index > -1) {
          this.rowActionButtons.splice(index, 1);
        }
      }
    })


  }

  ngOnInit() {
    this.auth.user$.subscribe(user => this.user = user)


    this.approvedDataSource.sort = this.sort;

    if (this.route.parent) {
      this.paramsSub = this.route.parent.params.subscribe((params: Params) => {
        this.siteId = params['siteId']
        console.log("siteId: ", this.siteId);
        this.categories$ = combineLatest([this.systemService.getAllSiteCategories$(this.siteId), this.systemService.getAllCategories$()])
          .pipe(map(cats => {
            return cats[0].map((cat) => {
              let findCat = cats[1].find(origCat => origCat.dbid == cat['categoryId'])

              return { ...findCat, ...cat }
            })
            // 
          }))
      })
    } else {
      this.siteId = this.inputSiteId
      this.categories$ = combineLatest([this.systemService.getAllSiteCategories$(this.siteId), this.systemService.getAllCategories$()])
      .pipe(map(cats => {
        return cats[0].map((cat) => {
          let findCat = cats[1].find(origCat => origCat.dbid == cat['categoryId'])

          return { ...findCat, ...cat }
        })
        // 
      }))
    }


  }


  addCategory() {

    const dialogRef = this.dialog.open(SitesCategoryPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId
      }
    });

    this.dialogSub = dialogRef.afterClosed().subscribe(async result => {



      // if (result) {
      //   const newUserData = result.value;
      //   // Check if any data was entered
      //   if ((!newUserData.name)) {
      //     this.notifierService.showNotification("error", "Employee id or name needs to be entered!")
      //     return;
      //   } else {
      //     // this.systemService.createCategory(newUserData);
      //   }
      // }
    });

    // this.router.navigate(['system/new'],{relativeTo:this.route})

  }



  deleteUser(id: number) {
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(id)
        this.systemService.deleteSiteCategory(id)
      }
    });

  }


  onBack() {
    this.router.navigate(['../'], { relativeTo: this.route })
  }

  showDetail(eventData) {
    let data = eventData
    data.siteId = this.siteId;

    // console.log("data", data)
    const dialogRef = this.dialog.open(CategoryDetailPopup, {
      disableClose: true,
      width: '700px',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }



  ngOnDestroy(): void {
    if (this.paramsSub) this.paramsSub.unsubscribe();
    if (this.dialogSub) this.dialogSub.unsubscribe();
    this.onDeleteSubscription.unsubscribe();
    this.onAddSubscription.unsubscribe();
    // this.onEditSubscription.unsubscribe();
  }

}



